import { render } from "./PageNotFound.vue?vue&type=template&id=46b16044&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=46b16044&scoped=true&lang=scss"

import exportComponent from "/home/ben/code/nft_ticket/nft_ticket_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b16044"]])

export default __exports__